import { ChangeDetectionStrategy, Component, Input, TemplateRef } from '@angular/core';
@Component({
  selector: 'm-footer-operations-bar',
  template: `
    <div class="m-footer-operations-bar-left" *ngIf="mFooterLeft">
      <ng-container *nzStringTemplateOutlet="mFooterLeft">{{ mFooterLeft }}</ng-container>
    </div>
    <div class="m-footer-operations-bar-center" *ngIf="mFooterCenter">
      <ng-container *nzStringTemplateOutlet="mFooterCenter">{{ mFooterCenter }}</ng-container>
    </div>
    <div class="m-footer-operations-bar-right" *ngIf="mFooterRight">
      <ng-container *nzStringTemplateOutlet="mFooterRight">{{ mFooterRight }}</ng-container>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  preserveWhitespaces: true,
  host: {
    class: 'm-footer-operations-bar'
  }
})
export class MFooterOperationsBarComponent {
  @Input() mFooterLeft?: string | TemplateRef<void>;
  @Input() mFooterCenter?: string | TemplateRef<void>;
  @Input() mFooterRight?: string | TemplateRef<void>;
}
